export default __webpack_public_path__ + "static/media/empty-message-list.63f9258c.svg";